import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-increment-posting-grid',
  templateUrl: './increment-posting-grid.component.html',
  styleUrls: ['./increment-posting-grid.component.css']
})
export class IncrementPostingGridComponent implements OnInit {

  title = "Post Increment";

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/Increments/increment-posting/increment-posting-grid/increment-posting-grid.component.ts